import debounce from 'lodash/debounce';

import { getStorageItems, setStorageItems } from '../../../shared/chromeApi';
import { browserStorageUpdate } from '../actions';
import { GlobalState } from '../../types.global';

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// -----------------------------------------------------------------------------

const IGNORED_EVENTS = [
  'searchForm/fetchEntities/pending',
  'tiles/fetchTiles/pending',
  'searchForm/discoveredCommand',
  'user/fetchedLoggedUser/pending',
  'searchForm/toggledInputFocus',
  'searchForm/userTyping',
  'searchForm/suggestionNavigate',

  'searchForm/fetchedSuggestions',
  'searchForm/fetchedInstantResults/pending',
  'searchForm/fetchedInstantResults/fulfilled',

  'searchForm/fetchedThinksuggestAds',
  'searchForm/searchTagSelected',

  'STORAGE_UPDATE',
];

const filterPersistent = (state) => {
  const filter = (obj, cb) =>
    Object.entries(obj).reduce(
      (acc, [key, value]) =>
        key.startsWith('$') ? acc : { ...acc, [key]: cb(value) },
      {}
    );

  return filter(state, (slice) => filter(slice, (v) => v));
};

const saveState = (state) => {
  try {
    const result = filterPersistent(state);
    const serializedState = JSON.stringify(result);
    localStorage.setItem('state', serializedState);
  } catch {
    // ignore write errors
  }
};

const storageMiddleware = ({ getState, dispatch }) => {
  const debouncedSaveBrowserStorage = debounce(() => {
    const result = filterPersistent(getState());
    setStorageItems(result);
  }, 500);

  const handleSubscribed = () => {
    const state = getState();
    saveState(state);
    debouncedSaveBrowserStorage();
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      debouncedSaveBrowserStorage.flush();
    });

    const debouncedUpdateState = debounce(() => {
      const payload = loadState();
      dispatch({ type: 'STORAGE_UPDATE', payload });
    }, 1000);

    setTimeout(() => {
      window.addEventListener('storage', (evt) => {
        if (evt.key !== 'state') return;
        debouncedUpdateState();
      });
    }, 3000);

    getStorageItems()
      .then((state: GlobalState) => {
        dispatch(
          browserStorageUpdate({
            state,
            isNewer:
              state?.user?.ntpVisitCounter > getState()?.user?.ntpVisitCounter,
          })
        );
      })
      .catch((err) => {
        // console.log('getStorageItems', err);
      });
  }

  return (next) => (action) => {
    const result = next(action);

    if (!IGNORED_EVENTS.includes(action.type)) {
      handleSubscribed();
    }

    return result;
  };
};

export default storageMiddleware;
